<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>FAQs</h1>
                        <span>트링카 관련 자주하는 질문 및 답변</span>
                        <!-- <a href="https://demo.trinka.ai/" target="_blank">Try it Now</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="verticalTabSection">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="questionSections">
                    <ul class="nav nav-tabs">
                        <li (click)="gotoTop()"><a class="active" href="#TrinkaTabs" data-toggle="tab">트링카</a></li>
                        <li (click)="gotoTop()"><a href="#AccountTabs" data-toggle="tab">사용자 계정</a></li>
                        <li (click)="gotoTop()"><a href="#AccountPaymentsTabs" data-toggle="tab">결제</a></li>
                        <li (click)="gotoTop()"><a href="#PlansTabs" data-toggle="tab">계획</a></li>
                        <li (click)="gotoTop()"><a href="#GeneralTabs" data-toggle="tab">일반</a></li>
                        <li (click)="gotoTop()"><a href="#SecurityTab" data-toggle="tab">보안</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-8">
                <div class="answersSections">
                    <div class="tab-content">
                        <div class="tab-pane active" id="TrinkaTabs">
                            <div class="accordion" id="TrinkaTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionOneContent">트링카는 무엇인가요?</a>
                                    </div>

                                    <div id="TrinkaQuestionOneContent" class="collapse show"
                                        aria-labelledby="TrinkaQuestionOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카는 AI 기반으로 만들어진 글쓰기 보조 툴로서 글에서 문법, 철자, 스타일, 일관성 오류를 체크하여 수정과 실행 가능한 피드백을 제시합니다. 단순한 수정 차원을 넘어 가장 적절한 어조와 스타일 개선점을 제안합니다. 또한 트링카는 편향적이고 민감한 언어 를 체크하고  간결한 글이 되도록 팁을 제공하여 중복된 표현을 줄이고 전문분야에 맞는 표현과 용어를 사용합니다. 그 외에도 학술적으로 애매모호한 단어(hedge words), 축약, 격식체 영어 등과 같은 학술 글의 특징을 살려 논문이 출판 준비가 잘 되어있는지 검토합니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTwoContent">트링카는 글을 검사할 때 다른 온라인 문법 툴과 어떻게 다른가요?</a>
                                    </div>

                                    <div id="TrinkaQuestionTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>일반 영문에 대해서는 여러 문법 검사기가 있지만 학술적 영어, 용어, 과학적 스타일, 출판 준비에 특화된 것은 극히 드뭅니다. 트링카는 학술적으로 영문 작성 경험이 부족한 저자들을 위해 맞춤 설계되었습니다. 이나고가 최근 비교한 결과에 따르면, 트링카는 매우 정확하게 글의 문제를 다양한 측면에서 점검하여 학술적으로 글쓰기에 가장 적합한 보조 툴입니다. <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">여기를 클릭하면</a> 백서를 볼 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionThreeContent">트링카는 저자의 글을 어떻게 검토하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카는 다양한 학술 전문 분야의 논문을 수백만 편으로 테스트하며 개발된 프로그램으로, 자연어 처리(NLP) 알고리즘과 문법 규칙을 조합하여 활용할수 있게 개발된 툴 입니다. 트링카는 최신 트렌드에 맞게 정기적으로 업데이트되고 엄격한 테스트를 거칩니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFourContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFourContent">트링카의 문법 검사기의 정확도는 어느 정도인가요?</a>
                                    </div>

                                    <div id="TrinkaQuestionFourContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFour" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카는 학술 컨텐츠에 맞게 설계되어 있어 학술적/기술적 컨텐츠에 가장 큰 효과를 발휘합니다. 이나고가 관련 데이터 그룹을 평가한 결과, 일반적으로 90% 이상의 정밀도(precision)와 80% 이상의 재현율(recall)을 발휘합니다. 이 균형은 이나고가 유지하는 가장 중요한 척도이며, 학술적/기술적 컨텐츠에서 뛰어난 결과를 얻을 수 있게 가장 중요한 역할을 합니다. 그 결과는 학술 전문분야에 따라 달라질 수 있습니다. 트링카는 고객이 주는 모든 피드백을 반영하여 지속적으로 툴의 <br>퀄리티가 최상으로 유지할수 있도록 합니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFiveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFiveContent">트링카는 무료로 사용할 수 있는 문법 검사기인가요?</a>
                                    </div>

                                    <div id="TrinkaQuestionFiveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFive" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 트링카의 베이직 레벨은 무료로 사용할 수 있습니다. 하지만 몇 가지 툴은 제한적일 수 <br>있습니다. 유료 섹션에 대한 자세한 사항을 <a [routerLink]="['/pricing']" >여기</a>를 클릭해서 확인해 보세요. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSixContent">트링카는 기술적 글쓰기를 어떻게 지원하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionSixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카는 AI 기반 문법 검사 툴로 3000가지 이상의 복잡한 문법 오류를 검사하고, APA와 AMA <br>스타일 가이드에 따라 모든 학술 전문 분야의 어조와 스타일, 포맷을 점검합니다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSevenContent">트링카를 사용하면 따로 교정하지 않아도 되나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionSevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>이는 원고 품질에 따라 다릅니다. 원어민 영어 사용자가 아니고 여러 복잡한 오류를 범해 영문의 논리적 구성이 약한 경우에는 교정 전문가의 도움을 받는 것을 추천합니다. 트링카는 수천 가지의 문법 오류와 글의 복잡한 문제를 수정합니다. 하지만 AI 수정으론 한계가 있습니다. 논문 구성이 논리적이지 않으면 저자가 의도한 의미를 해독할 수 없습니다. 이와는 반대로, 영어에 대한 지식도가 충분하고 논리적으로 올바르게 구성할 수 있다면 트링카로 어조, 단어 선택, 문법 구조, 철자 등과 같은 기존의 문제를 처리할 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionEightContent">논문을 쓸 때 트링카를 활용해도 괜찮나요? 논문의 문법 검사 용도로 사용할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 트링카는 모든 형태의 학술적/기술적 글에서 뛰어난 효과를 발휘합니다. 학위 논문, 연구 논문, 보고서, 에세이 등에 사용할 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionNineContent">Can Trinka check a PDF for grammar and or spelling issues? </a>
                                    </div>
    
                                    <div id="TrinkaQuestionNineContent" class="collapse" aria-labelledby="TrinkaQuestionNine"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Currently, Trinka supports MS Word files (doc/docx). We will add support for pdf and LaTeX files soon. </p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTenContent">트링카는 PDF 파일에서 문법이나 철자를 검사할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionTenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>현재까지 트링카는 MS Word 파일(doc/docx)만 지원하고 있습니다. 곧 pdf와 LaTeX 파일도 지원할 예정입니다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestioneleven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelevenContent">올바른 단어가 잘못된 철자라고 표시된다면 어떻게 해야 하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestioneleven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카의 AI 모델은 수백만 편의 출판된 논문을 통해 자동 업그레이드합니다. 하지만 새로운 단어를 접할 때가 있습니다. 분명히 올바른 철차인데 잘못된 철자라고 표시한다면, 제안 카드에 있는 '사전에 추가(Add to dictionary)’ 기능을 찾아 그 단어를 트링카 툴의 일부인 개인 사전에 추가해 <br>주세요. 트링카 사전에 새 단어를 추가하면 오류라고 표시하지 않습니다.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwelve">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwelveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwelveContent">트링카를 사용할 때 내 글이 표절된 것인지 표시되기도 하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwelveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwelve" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카는 언어 문제가 없도록 하기 위한 글쓰기 개선 작업을 도와드립니다. 표절은 출처를 정확히 밝히지 않고 출판된 텍스트를 사용하는 것입니다. 트링카를 사용하는 동안에는 표절이 발생하지 않겠지만, 문서에 트링카 표절 검사를 실시하여 혹시나 실수로 표절한 콘텐츠가 있는지 확인하는 것이 좋습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelThirteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelThirteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelThirteenContent">트링카는 APA 포맷에 맞게 포맷하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelThirteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelThirteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>예, Trinka에 내장된 APA 스타일 가이드 옵션을 사용하여 APA가 선호하는 모든 언어/작문 스타일을 적용할 수 있습니다. Trinka는 페이지, 여백, 번호 붙이기, 제목 스타일 등과 같은 APA 선호사항은 현재 적용하지 않는 점을 주의하기 바랍니다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFourteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFourteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFourteenContent">트링카는 영어 외에 다른 언어도 지원하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelFourteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFourteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>아니요, 트링카는 영문으로만 가능하도록 설계되었습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFiveteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFiveteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFiveteenContent">여러 기기에서 트링카에 액세스할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelFiveteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFiveteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>예! 컴퓨터(PC, Mac, Chromebooks), 태블릿(iPad, Android, Windows), 모바일 기기(iOS, Android, 기타 운영체제)에서 Trinka 웹사이트에 액세스할 수 있습니다. 현대 웹 브라우저를 지원하는 기기라면 어떤 것에서든 Trinka에 액세스할 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSixteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSixteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSixteenContent">트링카 API를 사용할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelSixteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSixteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>예. Trinka의 강력한 API는 어떤 애플리케이션에도 장착할 수 있습니다. 사용하기 쉬운 이 API는 높은 안정성과 확장성을 제공합니다. 자세한 사항은 <a
                                                [routerLink]="['/enterprise']">기업</a> 섹션을 방문해 보세요.
                                                </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSeventeen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSeventeenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSeventeenContent">여러 기기에서 동시에 트링카 계정에 로그인할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelSeventeenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSeventeen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>예. 하지만 한 기기를 초과해서 동일한 파일로 작업할 수 없는 점은 주의하기 바랍니다. 한번에 한 기기/브라우저에서만 Trinka로 파일을 교정할 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">What is the maximum word count Trinka can check?</a>
                                    </div>
    
                                    <div id="TrinkaQuestionelEighteenContent" class="collapse" aria-labelledby="TrinkaQuestionelEighteen"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka can check for language and grammar for up to 150 words on our demo tool, and this limit gets exceeded once you register for free.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelNineteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelNineteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelNineteenContent">워드파일의 어떤 버전이 트링카 워드 플러그인과 호환되나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelNineteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelNineteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카 워드 플러그인은 Windows에서 Microsoft Word 2010 이상 버전과 호환됩니다. 자세한 <br>내용은 <a [routerLink]="['/wordplugin']">여기를 클릭해 주</a>세요.
                                               </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">트링카는 크롬에서 작동하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelEighteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelEighteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, <a [routerLink]="['/browser-plugin']">여기</a>에서 트링카 크롬(Chrome) 브라우저 플러그인을 설치할 수 있습니다.
                                               </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwoenty">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwoentyContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwoentyContent">트링카는 파이어 폭스에서 작동하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwoentyContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwoenty" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, <a [routerLink]="['/browser-plugin']">여기</a>에서 트링카 파이어 폭스(Firefox) 브라우저 플러그인을 설치할 수 있습니다.
                                                </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyOneContent">는 Edge에서 작동하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyOneContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, <a [routerLink]="['/browser-plugin']">여기</a>에서 트링카 사파리(Edge) 브라우저 플러그인을 설치할 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyTwoContent">일부 웹사이트에서는 왜 트링카의 확장이 작동하지 않나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>컨텐츠 생성을 허용하는 웹사이트는 다양한 아키텍처와 디자인을 담고 있습니다. 때로는 웹<br>사이트가 트링카 확장 프로그램이 글을 읽는 방식을 방해할 수 있습니다. 올바르게 작동하지 않는 웹<br>사이트에 관해 피드백을 공유해 주시면 작동시킬 수 있는 방법을 트링카팀이 찾아보겠습니다. <br>도움이 필요하시면 언제든지 이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의 주세요.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyThreeContent">트링카는 페이스 북에서 작동하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 선호하는 브라우저 플러그인을 설치하면 사용 기능합니다. <a
                                                [routerLink]="['/browser-plugin']">여기</a>에서 브라우저 플러그인을 찾을 수 있습니다.
                                                </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyFoureContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyFoureContent">트링카는 LinkedIn에서 작동하나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyFoureContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyFoure" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 선호하는 브라우저 플러그인을 설치하면 사용 가능합니다. <a
                                                [routerLink]="['/browser-plugin']">여기</a>에서 브라우저 플러그인을 찾을 수 있습니다.
                                                </p>
                                        </div>
                                    </div>
                                </div>

                               

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySixContent">트링카는 LaTeX와 호환되나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>아니오, 현재까지는 LaTeX 파일을 지원하지 않습니다. 곧 이 형식을 지원하도록 추가할 예정입니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySevenContent">트링카가 문장에서 두 개 이상의 수정 사항을 보여주었는데 하나를 수정하니까 다른 하나가 사라졌습니다. 왜 그런가요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>첫 번째를 수정하면 두 번째 수정(또는 다른 수정)을 하지 않아도 되는 가능성이 있습니다. 사용자가 제안사항 중에 하나를 받아들여 해당 문장을 수정하면 트링카가 수정된 문장에 오류가 있는지 재확인합니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">라이팅 어드바이저(Writing Adviser)는 어떤 기능을 하고 언어 개선(Enhancements)과는 어떤 차이가 있나요?</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>라이팅 어드바이저는 글에 학술적 어조가 드러나길 원하는 저자를 위해 설계되었습니다. 이 기능은 학술적 영문 작성과 과학적 스타일에 특화되어 있습니다. 헤지(hedge)나 부스터(booster) 표현, 밋밋한 수식어, 능동태로 바꿀 수 있는 수동태 문장, 문장의 전반적인 품질에 대한 피드백을 제공합니다. 언어 개선(Enhancements)은 문법적으로는 문제 없지만 좀 더 개선하고 정돈할 여지가 있는 부분에 초점을 맞추는데, 예를 들어 단어 수를 줄이거나, 간결한 단어를 사용하거나, 편향되거나 민감한 언어를 중화하거나, 길고 복잡한 단어 대신 간단한 단어를 사용하는 등입니다.</p>
                                        </div>
                                    </div>
                                </div>




                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyEightContent">오프라인으로 트링카를 사용할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>아니요, 트링카는 인터넷 연결이 활성화되어야 글의 오류를 검사할 수 있습니다. 하지만 <a href="https://www.trinka.ai/kr/features/auto-file-edit">자동 파일 교정</a>(Auto File Edit) 기능을 활용하면 워드 파일을 업로드한 후 변경사항 추적 표시된 파일을 다운로드하여 오프라인으로 검토할 수 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyNineContent">트링카로 어떤 형식의 파일을 검사할 수 있나요?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyNineContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyNine" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>현재, 워드파일(doc/docx), txt 파일, rtf 파일을 지원합니다. 곧 pdf와 LaTeX 파일을 지원할 예정입니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionel30">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionel30Content" aria-expanded="true"
                                            aria-controls="TrinkaQuestionel30Content">트링카 표절 검사가 타사 도구보다 나은 점은 무엇인가요?</a>
                                    </div>

                                    <div id="TrinkaQuestionel30Content" class="collapse"
                                        aria-labelledby="TrinkaQuestionel30" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>다른 도구와 달리, 트링카를 사용하면 필요에 따라 맞춤화된 표절 검사를 선택할 수 있습니다. 예컨대 인터넷 콘텐츠만 선택하거나, 인터넷 콘텐츠 및 유료 출판물을 선택할 수 있습니다. 턴잇인(iThenticate)과 파트너십을 맺은 트링카의 기술은 전 세계 대형 학술 출판사가 신뢰하는 탁월한 탐지 기술을 제공해 드립니다. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountPaymentsTabs">
                            <div class="accordion" id="APTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="APQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionOneContent" aria-expanded="true"
                                            aria-controls="APQuestionOneContent">신용카드로 왜 결제가 되지 않나요?</a>
                                    </div>

                                    <div id="APQuestionOneContent" class="collapse show" aria-labelledby="APQuestionOne"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>결제가 되지 않는 경우 다양한 이유로 발생할 수 있습니다.</p>
                                            <ol>
                                                <li>신용카드가 해외 거래를 지원하지 않는 경우</li>
                                                <li>부정확한 정보를 입력한 경우</li>
                                                <li>신용카드 한도가 초과된 경우</li>
                                            </ol>
                                            <p>문제가 계속된다면 해당 거래 은행에 문의해 주시기 바랍니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="APQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionTwoContent" aria-expanded="true"
                                            aria-controls="APQuestionTwoContent">어떤 결제방식이 있나요?</a>
                                    </div>

                                    <div id="APQuestionTwoContent" class="collapse" aria-labelledby="APQuestionTwo"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>트링카는 현재 신용카드만 가능합니다. 해외 거래를 지원하는 모든 신용카드는 사용 가능합니다. 결제 관련 문제가 발생되는 경우를 이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의 바랍니다.
                                               </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionThreeContent">할인/코폰 코드는 어디에 입력하나요?</a>
                                    </div>

                                    <div id="GenernalQuestionThreeContent" class="collapse"
                                        aria-labelledby="GenernalQuestionThree" data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>할인 코드입력은 공유된 결제 링크를 통해 입력할 수 있습니다. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountTabs">
                            <div class="accordion" id="AccountQuestions">
                                <div class="card">
                                    <div class="card-header" id="AccountQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionOneContent" aria-expanded="true"
                                            aria-controls="AccountQuestionOneContent">브라우저 플러그인이 내 프리미엄 계정을 감지하지 못합니다.</a>
                                    </div>

                                    <div id="AccountQuestionOneContent" class="collapse show"
                                        aria-labelledby="AccountQuestionOne" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>브라우저 플러그인을 설치 후 바로 트링카 계정에 로그인해야 합니다. 로그인에 어려움이 있는 경우 이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 연락해 주시기 바랍니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionTwoContent" aria-expanded="true"
                                            aria-controls="AccountQuestionTwoContent">환불 가능한가요?</a>
                                    </div>

                                    <div id="AccountQuestionTwoContent" class="collapse"
                                        aria-labelledby="AccountQuestionTwo" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>이나고의 정책에 따라 구매한 구독에 대해서는 환불이 불가합니다. 구독 자동 갱신을 취소하는 경우 이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의 바랍니다.
                                               </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="AccountQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionThreeContent" aria-expanded="true"
                                            aria-controls="AccountQuestionThreeContent">I am unable to receive
                                            verification email</a>
                                    </div>

                                    <div id="AccountQuestionThreeContent" class="collapse"
                                        aria-labelledby="AccountQuestionThree" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>Please check the spam folder for the verification mail. If you still are
                                                unable to find the verification mail, then please contact our support on
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> and we will be
                                                glad to assist you.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionFoureContent" aria-expanded="true"
                                            aria-controls="AccountQuestionFoureContent">내 계정을 어떻게 삭제할 수 있나요?</a>
                                    </div>

                                    <div id="AccountQuestionFoureContent" class="collapse"
                                        aria-labelledby="AccountQuestionFoure" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 연락해 주세요. </p>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="tab-pane" id="PlansTabs">
                            <div class="accordion" id="PlansTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionOneContent" aria-expanded="true"
                                            aria-controls="PlanQuestionOneContent">구독은 자동 갱신되는가?</a>
                                    </div>

                                    <div id="PlanQuestionOneContent" class="collapse show"
                                        aria-labelledby="PlanQuestionOne" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p class="mb-2">구독은 자동 갱신된다. 자동 갱신을 취소하고자 한다면 다음과 같은 단계를 따른다.</p>
                                            <ul>
                                                <li>자신의 Trinka 계정으로 로그인 한다.</li>
                                                <li>대시보드 상단 우측의 “계정 설정”을 클릭한다.</li>
                                                <li>구독에서 제공된 “구독 갱신 취소”를 클릭한다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="PlanQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionTwoContent" aria-expanded="true"
                                            aria-controls="PlanQuestionTwoContent">Can I get a student discount?</a>
                                    </div>

                                    <div id="PlanQuestionTwoContent" class="collapse" aria-labelledby="PlanQuestionTwo"
                                        data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>Yes, student discounts are available. Write to us at <a
                                                    href="mailto:sales@trinka.ai">sales@trinka.ai</a> to know more and
                                                get your student discount.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="PlanQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionThreeContent" aria-expanded="true"
                                            aria-controls="PlanQuestionThreeContent">내 구독을 업그레이드할 수 있나요?</a>
                                    </div>

                                    <div id="PlanQuestionThreeContent" class="collapse"
                                        aria-labelledby="PlanQuestionThree" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 연락해 주세요. 곧 계정 설정에서 업그레이드할 수 있습니다.
                                                </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionFourContent" aria-expanded="true"
                                            aria-controls="PlanQuestionFourContent">그룹 구매의 경우 할인을 제공하나요?</a>
                                    </div>

                                    <div id="PlanQuestionFourContent" class="collapse"
                                        aria-labelledby="PlanQuestionFour" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 그룹 라이선스는 그룹의 규모에 따라 할인 받을 수 있습니다. 그룹 맞춤형 견적이 필요한 경우 이메일 <a
                                                href="mailto:sales@trinka.ai">sales@trinka.ai</a>로 문의해 주세요.
                                                 </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane" id="GeneralTabs">
                            <div class="accordion" id="GeneralTabsQuestion">
                                <!-- <div class="card">
                                    <div class="card-header" id="GeneralQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionOneContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionOneContent">How to enable grammar checker in
                                            MS Word?</a>
                                    </div>

                                    <div id="GeneralQuestionOneContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionOne" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Once you have installed Trinka MS Word Add-in, open any document in MS Word, look out for Trinka in the toolbar, and click
                                                to open it. Log in using your Trinka credentials if prompted. Once you
                                                are logged in, you should see the Trinka toolbar, and it should also
                                                start displaying the suggestions.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionTwoContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionTwoContent">문법 검사기 소프트웨어를 다운로드할 필요가 있나요?</a>
                                    </div>

                                    <div id="GeneralQuestionTwoContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionTwo" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>아니요, 트링카를 사용하기 위해 다운로드 해야할 소프트웨어는 따로 없습니다. 웹 브라우저에서 로그인만 하면 트링카를 사용 할 수 있습니다. 하지만 마이크로소프트 워드에서 트링카 문법 검사기를 사용하려는 경우에는 MS 워드 플러그인(곧 출시)을 설치해야 합니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionThreeContent">문맥 철자 검사기는 무엇인가요?</a>
                                    </div>

                                    <div id="GeneralQuestionThreeContent" class="collapse"
                                        aria-labelledby="GeneralQuestionThree" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>문맥 철자 검사기는 철자가 올바르지만 잘못된 문맥에 사용된 단어를 찾아냅니다. 예를 들어, 의도한 단어가 "site"인데 "sight"로 입력할 수 있습니다. 일반 철자 검사기는 이런 오류를 찾아낼 수 없습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFoureContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFoureContent">기술적 글쓰기는 일반 글쓰기과 어떻게 다른가요?</a>
                                    </div>

                                    <div id="GenernalQuestionFoureContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFoure" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>일반 글쓰기와 기술적 글쓰기는 둘 다 동일한 문법 규칙, 철자법, 구두법을 따릅니다. 하지만 기술적 글쓰기는 전문적인 어조와 스타일을 사용하고 사실 보고, 구체적 내용, 통계 등이 포함됩니다. 기술적 글쓰기는 의견을 담지 않지만 일반 글쓰기는 의견이 담깁니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFiveContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFiveContent">기술적 글쓰기는 학술적 글쓰기와 어떻게 다른가요?</a>
                                    </div>

                                    <div id="GenernalQuestionFiveContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFive" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>기술적 글쓰기는 서비스나 제품에 관한 상세하고 명확한 정보를 제공하는 데 집중합니다. 학술적 글쓰기는 이론이나 관점을 제시하는 데 초점을 맞추고 하나의 특정 주제를 강조합니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSixContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSixContent">트링카는 애플 맥 시스템과 호환되나요?</a>
                                    </div>

                                    <div id="GenernalQuestionSixContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSix" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 가능합니다. 모든 운영체제에서 트링카 클라우드(트링카 웹사이트)에 액세스할 수 있습니다. 윈도우와 맥 컴퓨터 모두에서 사용 가능한 트링카 Microsoft Word 애드인(add-in)을 곧 출시할 예정입니다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSevenContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSevenContent">제휴 프로그램이 있나요?</a>
                                    </div>

                                    <div id="GenernalQuestionSevenContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSeven" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>네, 트링카의 제휴 프로그램을 통해, 고객에게 트링카 웹사이트를 추천하면 수익을 올릴 수 있습니다. 가입은 무료입니다. 자세한 사항은 <a [routerLink]="['/affiliates']" >여기에</a>서 확인해 보세요.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">What does Writing Adviser do
                                            and how is it different from Enhancements?</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Writing Adviser is designed for writers who wish to employ an academic
                                                tone in their texts. These features are unique to academic English
                                                writing and scientific convention. It provides feedback on hedge or
                                                booster words, weak modifiers, passive voice sentences that can be
                                                changed to the active voice, and the overall quality of sentences.
                                                Enhancements cover only those aspects of writing which are grammatically
                                                sound but have scope for further improvement and polishing, e.g.,
                                                reducing the word count employing concise words, neutralizing biased or
                                                sensitive language, or using simpler words in place of longer, complex
                                                ones.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionNineContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionNineContent">문제에 직면할 때 해결하려면 어디로 문의해야 하나요?</a>
                                    </div>

                                    <div id="GenernalQuestionNineContent" class="collapse"
                                        aria-labelledby="GenernalQuestionNine" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의해 주세요.
                                                </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="tab-pane" id="SecurityTab">
                            <div class="accordion" id="SecurityTabQuestion">
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">Trinka가 내 비밀번호에 접근할 수 있나요?</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse show"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>아니오, Trinka는 비밀번호나 신용카드 정보와 같은 민감한 정보에 접근할 수 없습니다.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">내 데이터는 안전하고 비밀 유지가 되나요?</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>이나고는 개인정보 보호와 데이터를 철저하게 보안합니다. 데이터와 파일 전송 시 256비트 공개/비공개 키 암호화를 사용하며 세계적으로 높은 신뢰도로 인정받는 보안 인증서인 SSL 인증서를 보유하고 있습니다. 이나고는 개인 데이터를 제 3자와 공유하지 않습니다. 자세한 문의사항이 있는경우 이메일 <a
                                                href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의 바랍니다.
                                               </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="FAQFooterSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="FAQfooterText">
                    <h2>망설이지 말고 지금 사용해보세요.</h2>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">무료 가입하기</a>
                </div>
            </div>
        </div>
    </div>
</div>

 